declare const CONFIG: {
  VERSION: string;
  ENVIRONMENT: string;
  API_URL: string;
  TENANT: string;
};

export const { VERSION, ENVIRONMENT, API_URL, TENANT } = CONFIG;
export const APP = 'notifire';
